export default "<!-- <app-header></app-header> -->\n<app-header-lms></app-header-lms>\n<router-outlet></router-outlet>\n";